import { gql } from "@apollo/client";
import { MEMBER_BASIC_DETAILS } from "./fragments";

export const GET_ALL_MEMBERS = gql`
  ${MEMBER_BASIC_DETAILS}
  query members(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: Float
    $user: String
    $RFIDCard: String
    $biometricId: String
    $orderBy: String
    $isDeleted: Boolean
    $hasActiveMembershipPlan: Boolean
    $hasActiveTrainingPlan: Boolean
    $hasActiveDietPlan: Boolean
    $classSchedule: String
    $phone: String
    $ageStart: Float
    $ageEnd: Float
    $expiryDateEnd: Date
    $expiryDateStart: Date
    $createdOnStart: DateTime
    $createdOnEnd: DateTime
    $email: String
  ) {
    members(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      id: $id
      user: $user
      RFIDCard: $RFIDCard
      biometricId: $biometricId
      orderBy: $orderBy
      phone: $phone
      isDeleted: $isDeleted
      hasActiveMembershipPlan: $hasActiveMembershipPlan
      hasActiveTrainingPlan: $hasActiveTrainingPlan
      hasActiveDietPlan: $hasActiveDietPlan
      classSchedule: $classSchedule
      ageStart: $ageStart
      ageEnd: $ageEnd
      expiryDateEnd: $expiryDateEnd
      expiryDateStart: $expiryDateStart
      createdOnStart: $createdOnStart
      createdOnEnd: $createdOnEnd
      email: $email
    ) {
      edges {
        node {
          ...MemberBasicDetails
          bookedMembershipPackages {
            totalCount
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`;
export const GET_SINGLE_MEMBER = gql`
  query member($objectId: ID) {
    member(objectId: $objectId) {
      objectId
      discountGroup {
        id
        discountName
        objectId
      }
      totalWalletCredit
      height
      wakeUpTime
      bedTime
      weight
      gender {
        name
        objectId
      }
      user {
        objectId
        totalLoyaltyPoints
        dateOfBirth

        isProfilePicVerified
        rejectionReasonProfilePic

        dateJoined
        photo
        phone
        name
        contactNumber
        isEmailVerified
        email
        nationality {
          key
          name
        }

        isActive
        allowedDoorEntry
        doorOpenRequestCount
        addresses {
          edges {
            node {
              addressType {
                name
                objectId
              }
              address
              city {
                objectId
                name
              }
              state {
                name
                objectId
              }
              postalCode
              country {
                name
                objectId
              }
              objectId
            }
          }
        }
      }
      RFIDCard
      biometricId
      identityNo
      city {
        name
        objectId
      }
      additionalInfo
      trainer {
        objectId
        designation {
          name
          objectId
        }
        user {
          name
        }
      }

      medicalIssues {
        edges {
          node {
            objectId
            diseaseType {
              name
            }
            description
            isResolved
          }
        }
      }
    }
  }
`;
export const GET_SINGLE_MEMBER_DETAILS = gql`
  query member($objectId: ID) {
    member(objectId: $objectId) {
      objectId
      discountGroup {
        id
        discountName
        objectId
      }
      totalWalletCredit

      height
      wakeUpTime
      bedTime
      weight
      gender {
        name
        objectId
      }

      user {
        objectId
        totalLoyaltyPoints
        dateOfBirth
        registeredBranch {
          objectId
          name
        }
        isProfilePicVerified
        rejectionReasonProfilePic
        currentBranch {
          objectId
          name
        }
        dateJoined
        photo
        phone
        name
        contactNumber
        isEmailVerified
        email
        nationality {
          key
          name
        }

        isActive
        allowedDoorEntry
        doorOpenRequestCount
      }
      RFIDCard
      biometricId
      identityNo
      city {
        name
        objectId
      }
      additionalInfo
      trainer {
        objectId
        designation {
          name
          objectId
        }
        user {
          name
        }
      }
    }
  }
`;

export const GET_ALL_MEMBER_DISCOUNT_GROUP = gql`
  query memberDiscountGroups(
    $offset: Int
    $first: Int
    $code: String
    $forever: Boolean
    $discountName: String
    $orderBy: String
  ) {
    memberDiscountGroups(
      offset: $offset
      first: $first
      code: $code
      forever: $forever
      discountName: $discountName
      orderBy: $orderBy
    ) {
      edges {
        node {
          createdOn
          discountName
          discount
          code
          quantity
          objectId
          start
          end
          forever
          id
        }
      }
    }
  }
`;
export const GET_SINGLE_MEMBERSHIP_PACKAGE_BOOKING = gql`
  query membershipPackageBooking($objectId: ID) {
    membershipPackageBooking(objectId: $objectId) {
      createdOn
      actualPrice
      price
      vatPercent
      priceWithVat
      package {
        name
        duration {
          days
          name
        }
        objectId
      }
      status
      startDate
      endDate
      rejectReason
      freezingEnd
      freezingStart
      objectId
      discountAmount
      isExpired
      invoice
      paidAmount
      member {
        objectId
        user {
          name
        }
      }
    }
  }
`;
export const GET_ALL_INVOICE_RECEIPT = gql`
  query invoiceReceipts(
    $offset: Int
    $first: Int
    $orderBy: String
    $invoice: String
    $customer: String
  ) {
    invoiceReceipts(
      offset: $offset
      first: $first
      orderBy: $orderBy
      invoice: $invoice
      customer: $customer
    ) {
      totalCount
      edges {
        node {
          objectId
          note
          paidAmount
          paymentType
          deliveryReport
          balance
          invoiceAmount
          createdOn
        }
      }
    }
  }
`;
export const GET_SINGLE_INVOICE_RECEIPT = gql`
  query invoiceReceipt($objectId: ID) {
    invoiceReceipt(objectId: $objectId) {
      createdOn
      customer {
        user {
          name
        }
      }
      createdBy {
        name
      }
      paidAmount
      bank {
        name
      }
      chequeAmount
      chequeNo
      chequeDate
      objectId
      paymentType
      invoiceAmount
      deliveryReport
      balance
    }
  }
`;
export const GET_MEMBER_MEMBER_SHIP_BOOKING = gql`
  query allMembershipPackageBookings($member: String) {
    allMembershipPackageBookings(member: $member) {
      edges {
        node {
          objectId
          package {
            name
            objectId
          }
          discountAmount
          invoice
          isPaid
          startDate
          priceWithVat
          status
          endDate
          actualPrice
          price
          paidAmount
          vatPercent
        }
      }
    }
  }
`;
export const GET_MEMBER_PERSONAL_TRANINING_BOOKING = gql`
  query allPersonalTrainingPackageBookings($member: String) {
    allPersonalTrainingPackageBookings(member: $member) {
      edges {
        node {
          objectId
          package {
            name
            objectId
          }
          discountAmount
          invoice
          isPaid
          startDate
          priceWithVat
          status
          endDate
          actualPrice
          price
          paidAmount
          vatPercent
        }
      }
    }
  }
`;
export const GET_MEMBER_DIET_PLAN_BOOKING = gql`
  query allDietPlanPackageBookings($member: String) {
    allDietPlanPackageBookings(member: $member) {
      edges {
        node {
          objectId
          package {
            name
            objectId
          }
          discountAmount
          invoice
          isPaid
          startDate
          priceWithVat
          status
          endDate
          actualPrice
          price
          paidAmount
          vatPercent
        }
      }
    }
  }
`;
